<div class="notifcation-badges">
  @if (isMentioned()) {
    <div [attr.data-testid]="dataTestIdMention()" class="mention-badge">
      <span class="mention-indicator"> &#64; </span>
    </div>
  }
  @if (count()! > 0) {
    <div [attr.data-testid]="dataTestId()" class="counter-badge">
      <span class="counter">+{{ count() }}</span>
    </div>
  }
</div>
